import {
  Crown,
  Zap,
  Headset,
  Wrench,
  Building,
  ThumbsUp,
  Award,
  CheckCircle,
} from "lucide-react";
import ChimneymainImg from "../img/Director.jpg";
import CTA from "./Cta";

function AboutUs() {
  return (
    <>
      <section className="hob-about-hero">
        <div className="hob-about-hero-content">
          <h1 className="hob-about-title">
            Welcome to Lokesh Mandal Constructions
          </h1>
          <p className="hob-about-subtitle">
            The right team for your dream projects.
          </p>
        </div>
      </section>

      <section className="hob-aboutus-section">
        <div className="hob-aboutus-container">
          <div className="hob-aboutus-left">
            <p className="hob-aboutus-text">
              Lokesh Mandal Constructions & Engineering Pvt. Ltd., established
              in 2017, is a trusted name in construction and infrastructure,
              focused on building excellence and functionality in modern spaces.
              We specialize in delivering high-quality residential, commercial,
              and industrial construction projects with strong attention to
              detail and engineering precision.
            </p>

            <p className="hob-aboutus-text">
              From residential complexes to commercial buildings, we ensure
              precision, durability, and reliability in every project we handle.
              Our team works closely with clients, architects, and engineers to
              transform ideas into strong and sustainable structures.
            </p>

            <p className="hob-aboutus-text">
              Founded with a passion for construction excellence, our journey
              began with a single goal: to elevate the standard of building and
              infrastructure development through innovation, quality materials,
              and modern construction techniques.
            </p>

            <p className="hob-aboutus-subtext">
              Today, we operate with a team of highly trained engineers,
              supervisors, and skilled workers using state-of-the-art
              construction equipment and advanced project management systems.
              This ensures that every project is completed with the highest
              standard of quality, safety, and efficiency.
            </p>

            <p className="hob-aboutus-subtext">
              We believe in clear communication, transparency, and timely
              delivery. Customer satisfaction, quality construction, and
              long-term relationships are the core values that drive our company
              forward.
            </p>

            <p className="hob-aboutus-subtext">
              At Lokesh Mandal Constructions, premium quality isn't optional —
              it's our promise. We don't just build structures; we build trust,
              reliability, and long-lasting partnerships with our clients.
            </p>
          </div>

          <div className="hob-aboutus-right">
            <div className="hob-aboutus-image-wrapper">
              <img
                src={ChimneymainImg}
                alt="Lokesh Mandal - Director"
                className="hob-aboutus-image"
              />
              {/* Add Director caption below image */}
              <div className="hob-aboutus-director-caption">
                <h4 className="hob-aboutus-director-name">Lokesh Mandal</h4>
                <p className="hob-aboutus-director-title">Director</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Section 3: Values */}
      <section className="hob-about-values">
        <div className="hob-about-values-grid">
          <div className="hob-about-value-card">
            <Crown size={32} className="hob-about-icon" />
            <h3 className="hob-about-value-title">Premium Quality</h3>
            <p className="hob-about-value-text">
              Top-tier construction with a steadfast commitment to quality and
              durability
            </p>
          </div>
          <div className="hob-about-value-card">
            <Zap size={32} className="hob-about-icon" />
            <h3 className="hob-about-value-title">Timely Delivery</h3>
            <p className="hob-about-value-text">
              Efficient project management and trusted execution when every
              deadline counts.
            </p>
          </div>
          <div className="hob-about-value-card">
            <Headset size={32} className="hob-about-icon" />
            <h3 className="hob-about-value-title">24/7 Client Support</h3>
            <p className="hob-about-value-text">
              We are ready to assist day or night, whenever you need expert
              guidance.
            </p>
          </div>
          <div className="hob-about-value-card">
            <Wrench size={32} className="hob-about-icon" />
            <h3 className="hob-about-value-title">Expert Engineers</h3>
            <p className="hob-about-value-text">
              Certified professionals equipped with state-of-the-art
              construction technology.
            </p>
          </div>
        </div>
      </section>

      <CTA />
    </>
  );
}

export default AboutUs;
